import * as actionTypes from './actionTypes'
import {
  getHSDtlList,
  getHSTotalDCT,
  gethsDataDtlListBody
} from '../api/htsRequests'
import { chinaExlcusionHTSTriggers } from '../util'
import {
  saveLineItemDuties,
  saveDescriptionOfMerchandiseDutyItem,
  saveDescriptionOfMerchandiseDutyItemArray,
  saveTotals,
  saveDescriptionOfMerchandiseLineItem
} from '../api/setFormData'
import { deleteMerchandise, deleteDuty, deleteUserFee , deleteInvoice} from '../api/deleteFormData'
import { HTS_DTL_CAL_MODES } from '../util/constants'
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

import _ from 'lodash'
// import { calculateNewTotals } from './util'
import store from '../store'
import { formatHTS } from '../util'
import {invoiceItemData}  from "../formSections/util/initialValues"
import { entryTypeFields } from '../util/supportedFields/entryType'
import  {isEmpty} from 'lodash'
import { getState } from '../../util/handleStates'
import { createMerchandiseDutyItem } from '../api/createItem'
import { hasDutyOverride } from '../formSections/merchandiseSections/DutyItem'
import { allPossibleChinaExlcusionHTSTriggers, hasFieldKN } from '../util/index'
import { getExclusionHTSES } from '../formSections/util/constants'
import { HttpClient } from '../api/httpClient'
// Takes in a list fo HTS and calls API to get PGS associated with each HTS
// Initially functionality will only work for single HTS being fed in from a specific lineItemIndex
// TODO: refactor to service all lineItems if needed

export const russiaTarriffCodes = ["25010000","25120000","25140000","25199050","25309080","27030000","28070000","28112100","28112910","28121900","28129000","28151100","28170000","28181010","28181020","28256000","28257000","28259015","28259090","28261990","28272000","28273100","28273200","28273500","28273925","28273945","28273955","28273960","28273965","28273990","28274950","28275925","28275951","28276010","28276051","28332951","28342920","28342951","28352200","28353100","28362000","28366000","28369950","28371901","28402000","28419050","28429090","28439000","28492020","28499010","28499020","28500050","28539050","28539090","29011010","29012200","29012910","29012950","29021900","29022000","29023000","29027000","29031200","29034110","29034210","29034310","29034410","29034510","29034610","29034710","29034800","29034900","29035110","29035910","29035990","29036990","29037800","29037990","29038970","29051990","29054100","29054200","29141900","29147990","29152950","29153990","29154050","29155010","29157001","29159018","29159050","29161100","29161250","29161420","29161930","29181350","29199050","29211100","29211961","29232020","29252990","29269050","29299050","29301001","29309030","29309092","29311000","29314400","29314800","29314900","29315100","29315200","29315300","29315400","29315900","29319090","29321951","29329990","29337985","29420050","32011000","32091000","32149010","32159050","34011150","34012000","34013050","34024990","34025051","34029050","34039900","34049051","34059000","34060000","35069150","35069900","35079070","36033000","36034000","36035000","36036000","37013000","37019100","37023101","37039030","38012000","38040050","38112900","38151900","38180000","38244050","38249911","39021000","39022010","39046100","39046910","39046950","39069050","39072100","39072900","39100000","39172900","39173200","39173300","39173900","39201000","39202000","39206200","39209100","39209200","39211350","39249010","39262090","39269030","39269040","39269045","39269060","39269096","40012200","40021900","40022000","40023100","40023900","40025900","40030000","40059100","40059900","40081110","40091200","40092200","40093100","40093200","40094200","40101100","40103130","40103160","40111010","40111050","40112010","40113000","40114000","40117000","40118020","40119010","40121180","40122060","40122080","40129010","40139010","40159000","40169310","40169350","40169500","42022920","42032950","43021930","44013100","44013200","44013942","44042000","44071100","44071200","44071300","44071900","44072301","44072902","44079100","44079600","44081001","44089001","44091010","44091020","44091040","44091090","44092210","44092240","44092926","44092961","44092991","44111410","44111460","44119210","44141000","44149000","44151090","44182180","44182980","44184000","44187410","44188100","44188200","44188300","44188900","44189200","44189991","44192090","44199091","44201100","44201900","44209045","44209065","44209080","44212010","44212020","44219194","44219198","44219910","44219960","44219970","44219993","44219994","44219998","48022020","48041900","48042100","48051100","48051910","48051920","48052500","48059240","48061000","48115940","48149002","48201020","48211020","48237000","49011000","49019100","49019900","49021000","49029010","49029020","49030000","49040000","49060000","49070000","49089000","49090020","49100020","49111000","49119110","49119140","52051320","59031020","59100090","62160013","62160038","63013000","63021000","63022190","63023190","63025110","64031970","64035990","64039160","64039190","64039990","64051000","64069060","65061060","67030030","68022150","68029105","68030010","68030050","68041000","68042100","68042260","68042300","68043000","68053010","68053050","68061000","68062000","68071000","68109900","68118200","68159941","69032000","69039000","69120010","69131010","70109050","71022110","71031020","71039100","71039910","71049110","71049910","71051000","71059000","71069110","71069210","71081355","71159005","71181000","71189000","72021150","72022110","72022900","72023000","72024100","72024910","72027000","72042100","72042900","72044900","72052900","72071200","72169100","72249000","73042910","73042920","73042931","73042941","73042950","73062920","73062960","73079910","73089060","73101000","73102900","73110000","73144100","73181520","73181540","73181600","73182200","73251000","74081160","74081900","74092100","74102200","75062030","76042930","76042950","76051100","76061230","76061260","76130000","78011000","78019990","82055930","82072000","82089060","83023030","83052000","84069075","84082010","84089010","84122100","84122980","84123100","84123900","84129090","84211100","84425010","84439110","84439130","84553000","84559080","84561110","84581100","84593900","84596100","84603900","84609080","84621100","84621900","84622200","84622300","84622400","84622500","84622600","84622900","84626180","84626250","84626380","84626980","84629080","84631000","84669315","84671110","84679901","84831050","84834010","84834050","84834090","84839050","85122020","85234920","85391000","85393100","85393200","85414100","85443000","85469000","86071912","86090000","87011001","87019450","87019510","87031050","87032101","87032301","87032401","87043101","87045100","87060015","87071000","87081060","87082915","87082925","87082951","87083050","87084011","87084030","87084050","87084065","87084070","87084075","87085099","87087060","87088016","87088065","87089175","87089210","87089250","87089275","87089475","87089941","87089948","87089968","87089981","87113000","87114060","87119001","87141000","87149210","87149980","87168010","88022001","88061000","88062100","88062200","88062300","88062400","88062900","88069100","88069200","88069300","88069400","88069900","88071000","88072000","88073000","88079090","89031100","89031200","89031900","89033100","89033200","89033300","89039390","89039991","90022040","90069100","90079140","90089080","90142080","90148050","90230000","93040040","93052080","93062100","93063041","94012000","94019115","94019910","94035060","94037080","94039100","94039910","94039940","94044010","94049081","94061000","95044000","95051015","95051025","95059060","95061120","95069925","96031090","97012100","97012200","97012900","97019100","97019200","97019900","97021000","97029000","97031000","97039000","97040000","97051000","97052100","97052200","97052900","97053100","97053900","97061000","97069000"];

export const russiaAdditionalCostHTS = ["99039008"]

export function checkIfRussiaTarriffAlreadyApplied(merchandiseData){
  if(((window.LAST_TIME_APPLIEDRUS||0) + 3000) > Date.now()){
    return true;
  }
  let applied = false;
  merchandiseData.merchandiseDuties.map((item,iiii)=>{
    if(russiaAdditionalCostHTS.includes(item.htsus.replace(/[\.]/g, '')) && item.isCommodity!==1){
      applied = true;
    }
    if(iiii>0 && [...russiaAdditionalCostHTS,...russiaTarriffCodes].map(a=>a.replace(/[\.]/g, '')).find(a=>a.startsWith(item.htsus.replace(/[\.]/g, '')))){
      applied = true;
    }
  })
  if(!applied)window.LAST_TIME_APPLIEDRUS = Date.now();
  return applied;

}

export function checkIfSimilarApplied( merchandiseData){
  
  for(let item of ((merchandiseData?.merchandiseDuties)||[])){
    let htsMatcher = item.htsus.replace(/[\.]/g, '');
    

    if(htsMatcher.indexOf("990388" == 0) ) { //["99038801","99038803"]
      if( merchandiseData.merchandiseDuties.indexOf(item) == 0)continue;
      return ({
        appliedChinaDuty : true,
        chinaDutyIndex: merchandiseData.merchandiseDuties.indexOf(item),
        merchandiseDutyId: item.merchandiseDutyId
      });
    }
  }
  return ({
    appliedChinaDuty : false,
    chinaDutyIndex: -1,
  });
  
}


export function checkIfAlreadyApplied(tarrifData, merchandiseId, merchandiseData, entryDate){
  if(((window["LAST_TIME_APPLIED"+merchandiseId]||0) + 6000) > Date.now()){
    return true;
  }
  
  
    
  let applied = false;
  merchandiseData.merchandiseDuties.map((item,iiii)=>{
    if(item.htsus.replace(/[\.]/g, '') === tarrifData.htsNo.replace(/[\.]/g, '') && item.isCommodity!==1){
      applied = true;
    }
    if(iiii>0 && allPossibleChinaExlcusionHTSTriggers().map(a=>a.replace(/[\.]/g, '')).find(a=>a.startsWith(item.htsus.replace(/[\.]/g, '')))){
      applied = true;//china exclusion
    }
  })
  if(!applied)window["LAST_TIME_APPLIED"+merchandiseId] = Date.now();
  return applied;
}

export function setHSDTL(
  itDate,
  allEntryData,
  hts,
  invoiceItemIndex,
  lineItemIndex,
  dutyIndex,
  isCommodityDuty,
  onLoad,
  invoiceId,
  merchandiseId,
  countryOfOrigin,
  merchandiseData,
  deleteOldPGACVDData,
  callbackFunctionHsdtl
) {
  const isBrokerKnAdmin= allEntryData?.allEntryData?.isBrokerKnAdmin || allEntryData?.isBrokerKnAdmin;
  let isBlankTest = (input)=>{
    if(!input)return true;
    if(input == "_BLANK_")return true;
    return false;
  }
  return (dispatch, getState) => {
    let hsCodeRoot = formatHTS(hts)
    if (!hsCodeRoot) {
      return dispatch(updateHSDataDtl({},invoiceItemIndex, lineItemIndex, dutyIndex))
    }
    let ninetyEightNinetyNineChapter = parseInt(hsCodeRoot.substring(0,2))>97;
    let myDutyCurrent = _.get(merchandiseData,`merchandiseDuties[${dutyIndex}]`,{});

    getHSDtlList(itDate, allEntryData, formatHTS(hsCodeRoot),countryOfOrigin)
      .then(response => {

        // Just save metadata incase of aggregated view
        if(allEntryData?.useAggregated === "true"){
          let hsDataDtl =  _.get(response, 'data.eventMessage', false)
          dispatch(
            updateHSDataDtl(
              hsDataDtl,invoiceItemIndex,
              lineItemIndex,
              dutyIndex,
            )
          )
          return
        }
        callbackFunctionHsdtl && callbackFunctionHsdtl();
        let hsDataDtl =  _.get(response, 'data.eventMessage', false)
        deleteOldPGACVDData && deleteOldPGACVDData(hsDataDtl);
        if (hsDataDtl.htsNo) {
          let dutyRateVariable = hsDataDtl.applicableDuty || "";
          let otherRate = hsDataDtl.column1OtherRate || "";
          let specificRate = hsDataDtl.column1SpecificRate || "";
          
          if(["RU","CU","KP","BY"].includes(countryOfOrigin)){//russia, cuba, north korea, belarus
            specificRate = hsDataDtl.column2SpecificRate || "";
          }
          let errorCode = hsDataDtl?.header?.code;
          let productClaimCode = store.getState().DescriptionOfMerchandise.entrySummaryInvoices[invoiceItemIndex].merchandiseLineItems[lineItemIndex].productClaimCode;
         // console.log("merch", store.getState().DescriptionOfMerchandise.merchandiseLineItems[lineItemIndex])
         let dutyRateAppliedDueToNoTradeDeal = ninetyEightNinetyNineChapter /*no trade deals for 98,99*/ || 
          (!productClaimCode || productClaimCode==='NONE' || productClaimCode==='_BLANK_' || productClaimCode=="NA");
          let changeDetected = false;
          for(let comparisonPair of [
            {objectVal:merchandiseData?.merchandiseDuties[dutyIndex]?.otherRate, newVal:otherRate},
            {objectVal:merchandiseData?.merchandiseDuties[dutyIndex]?.specificRate, newVal:specificRate},
            {objectVal:merchandiseData?.merchandiseDuties[dutyIndex]?.dutyRate, newVal:dutyRateVariable},
          ]){
            changeDetected = changeDetected || !!(parseFloat(comparisonPair.objectVal).toFixed(2) !== parseFloat(comparisonPair.newVal || "0.00").toFixed(2));

          }


          if (!isBrokerKnAdmin) {//START DUTY SAVE
            if (dutyRateVariable && dutyRateAppliedDueToNoTradeDeal && changeDetected) {
              dispatch(
                updateMerchDutyItemFeild(
                  invoiceItemIndex,
                  lineItemIndex,
                  dutyIndex,
                  'dutyRate',
                  parseFloat(dutyRateVariable).toFixed(2)
                )
              )
            }
            if (specificRate && dutyRateAppliedDueToNoTradeDeal && changeDetected) {
              dispatch(
                updateMerchDutyItemFeild(
                  invoiceItemIndex,
                  lineItemIndex,
                  dutyIndex,
                  'specificRate',
                  parseFloat(specificRate).toFixed(2)
                )
              )
            }
            if (otherRate && dutyRateAppliedDueToNoTradeDeal && changeDetected) {
              dispatch(
                updateMerchDutyItemFeild(
                  invoiceItemIndex,
                  lineItemIndex,
                  dutyIndex,
                  'otherRate',
                  parseFloat(otherRate).toFixed(2)
                )
              )
            }

            if (isCommodityDuty === 1) {
              if (hsDataDtl.permitTypeCode) {
                dispatch(updateMerchLineItemFeild(lineItemIndex, invoiceItemIndex, 'permitTypeCode', hsDataDtl.permitTypeCode))
                dispatch(saveDescriptionOfMerchandiseLine(lineItemIndex, invoiceItemIndex, 'permitTypeCode', hsDataDtl.permitTypeCode))
              }
              else {
                // if (!isBlankTest(merchandiseData.permitTypeCode) || !isBlankTest(merchandiseData.permitNumber) && allEntryData?.hsDtlCalledFrom=="htsus") {
                //   setTimeout(() => {
                //     dispatch(updateMerchLineItemFeild(lineItemIndex, invoiceItemIndex, 'permitTypeCode', 'NONE_PERMIT_TYPE_CODE'))
                //     dispatch(updateMerchLineItemFeild(lineItemIndex, invoiceItemIndex, 'permitNumber', '_BLANK_'))
                //     dispatch(saveDescriptionOfMerchandiseLine(lineItemIndex, invoiceItemIndex, 'permitNumber', '_BLANK_'))
                //     dispatch(saveDescriptionOfMerchandiseLine(lineItemIndex, invoiceItemIndex, 'permitTypeCode', 'NONE_PERMIT_TYPE_CODE'))
                //     dispatch(clearDescriptionOfMerchandiseLine(lineItemIndex, invoiceItemIndex, 'permitTypeCode'))
                //   }, 2500)
                // }
              }
            }

            if (changeDetected && dutyRateAppliedDueToNoTradeDeal) {
              setTimeout(() => {//the duty rate change happens last so that the duty value isn't overwritten
                dispatch(
                  saveMerchDutyItem(lineItemIndex, invoiceItemIndex, dutyIndex, 
                        ["dutyRate",                              "otherRate",                      "specificRate"], 
                        [parseFloat(dutyRateVariable).toFixed(2), parseFloat(otherRate).toFixed(2), parseFloat(specificRate).toFixed(2)] )
                )
              }, 1000);
            }
          }//END DUTY SAVE
          
          
            
            if(hsDataDtl.userfeeDetails && !onLoad && allEntryData?.hsDtlCalledFrom=="htsus"){
              let useFeeObj = {}
              let comparisonFeeObject = _.get(merchandiseData,`merchandiseDuties[${dutyIndex}].additionalDuties.userFees[0]`,{});
              if(!_.isEmpty(hsDataDtl.userfeeDetails)){
                useFeeObj["dutyType"] = hsDataDtl.userfeeDetails.dutyType;
                useFeeObj["isRequired"] = hsDataDtl.userfeeDetails.isRequired;
                useFeeObj["specificRate"] = hsDataDtl.userfeeDetails.specificRate;
                useFeeObj["adValoremRate"] = hsDataDtl.userfeeDetails.adValoremRate;
                useFeeObj["computationCode"] = hsDataDtl.userfeeDetails.computationCode; 
              }
              if(!_.isEqual(comparisonFeeObject,useFeeObj)){
                dispatch(addUserFee(lineItemIndex,invoiceItemIndex, dutyIndex, useFeeObj))
                dispatch(
                  saveMerchDutyItem(lineItemIndex,invoiceItemIndex, dutyIndex, "additionalDuties")
                )
              } else {
                
                window.console.log('useFeeObj: ', useFeeObj,comparisonFeeObject, _.isEqual(comparisonFeeObject,useFeeObj));
              }
            }
            // if data was returned
          if (isCommodityDuty === 1) {
            // Update fields that isCommodity Duty Controls

            // Save All hsData
            dispatch(
              updateHSDataDtl(
                hsDataDtl,invoiceItemIndex,
                lineItemIndex,
                dutyIndex,
              )
            )
            // Update values if HTS is explicitely changed
            if (!onLoad) {
              let newTextileCode = parseInt(hsDataDtl.textileCategoryCode) && parseInt(merchandiseData.categoryCode) != parseInt(hsDataDtl.textileCategoryCode);
              let noTextileCode = !parseInt(hsDataDtl.textileCategoryCode) && parseInt(merchandiseData.categoryCode)
              if(newTextileCode || noTextileCode ){
                let newTextileValue = hsDataDtl.textileCategoryCode || "-999";
                dispatch(
                updateMerchLineItemFeild(
                  lineItemIndex,
                  invoiceItemIndex,
                  'categoryCode',
                  newTextileValue
                ))
                saveDescriptionOfMerchandiseLineItem(merchandiseId, invoiceId, 'categoryCode', newTextileValue, {}).then((responseTextiles)=>{
            
                })

              }
            }

          }

            if(!isBrokerKnAdmin){
              // Update and Save manifestQuantity units
              let unitOne =  hsDataDtl.unit1 || "";

              const conversionTable = {
                PCS : { 
                  NO : 1, 
                  DOZ : 1/12  
                },
              }
              const upperCaseAndTrim = (str)=>{
                return (str+"").toUpperCase().trim();
              }
              const convertThisUnit = conversionTable[upperCaseAndTrim(myDutyCurrent?.manifestQuantity?.units)] && conversionTable[upperCaseAndTrim(myDutyCurrent?.manifestQuantity?.units)][upperCaseAndTrim(unitOne)];
              // console.table([{
              //   currentUnit: myDutyCurrent?.manifestQuantity?.units,
              //   newUnit: unitOne,
              //   convertThisUnit,
              //   htsHasBeenLengthZero : allEntryData?.htsHasBeenLengthZero
              // }])
              if (myDutyCurrent?.manifestQuantity?.units != unitOne && (["_BLANK_", "" ].includes(unitOne) || convertThisUnit || allEntryData?.htsHasBeenLengthZero )) {
                if(allEntryData.parentThis){
                  allEntryData.parentThis.setState({htsHasBeenLengthZero: false});
                }
                // console.log("INSIDEEEEEEEEEEEEEE")
                if(["","_BLANK_"].includes(myDutyCurrent?.manifestQuantity?.units) || myDutyCurrent?.isCommodityDuty === 1){
                  dispatch(
                    updateMerchDutyItemObject(
                      lineItemIndex, invoiceItemIndex,
                      dutyIndex,
                      'manifestQuantity',
                      'units',
                      unitOne || "_BLANK_"
                    )
                  )
                }
                if(!myDutyCurrent?.manifestQuantity?.quantity || myDutyCurrent?.isCommodityDuty === 1){
                  if(["_BLANK_", ""].includes(unitOne)){
                    dispatch(
                      updateMerchDutyItemObject(
                        lineItemIndex, invoiceItemIndex,
                        dutyIndex,
                        'manifestQuantity',
                        'quantity',
                        "0"
                      )
                    )
                  }
                }
                if(convertThisUnit && convertThisUnit != 1){
                  dispatch(
                    updateMerchDutyItemObject(
                      lineItemIndex, invoiceItemIndex,
                      dutyIndex,
                      'manifestQuantity',
                      'quantity',
                      Math.max((convertThisUnit||0) * parseFloat(myDutyCurrent?.manifestQuantity.quantity||0), 0).toFixed(2)
                    )
                  )
                }
                dispatch(
                  saveMerchDutyItem(lineItemIndex,invoiceItemIndex, dutyIndex, 'manifestQuantity')
                )
              }
            }
            if (isCommodityDuty === 1) {
            if (!onLoad && !isBrokerKnAdmin) {
              // Update and Save additionalQuantity units
              let unitTwo =  hsDataDtl.unit2 || "_BLANK_";
              const eitherHasAUnit = hasFieldKN(myDutyCurrent?.additionalQuantity?.units) || hasFieldKN(unitTwo);
              if (myDutyCurrent?.additionalQuantity?.units != unitTwo && eitherHasAUnit) {
                dispatch(
                  updateMerchDutyItemObject(
                    lineItemIndex,invoiceItemIndex,
                    0,
                    'additionalQuantity',
                    'units',
                    unitTwo
                  )
                )
                dispatch(
                  saveMerchDutyItem(lineItemIndex,invoiceItemIndex, 0, 'additionalQuantity')
                )
              } 
              // Update and Save HTS Description
              // if (hsDataDtl.displayDescription) {
              //   dispatch(
              //     updateMerchDutyItemFeild(
              //       invoiceItemIndex,
              //       lineItemIndex,
              //       dutyIndex,
              //       'htsDescription',
              //       hsDataDtl.displayDescription
              //     )
              //   )
              //   dispatch(
              //     saveMerchDutyItem(lineItemIndex,invoiceItemIndex, dutyIndex, 'htsDescription')
              //   )
              // }
              // // If no dispalyDesc Update and Save HTS Description to _BLANK_
              // else if (!hsDataDtl.displayDescription) {
              //   dispatch(
              //     updateMerchDutyItemFeild(invoiceItemIndex,
              //       lineItemIndex,
              //       dutyIndex,
              //       'htsDescription',
              //       '_BLANK_'
              //     )
              //   )
              //   dispatch(
              //     saveMerchDutyItem(lineItemIndex,invoiceItemIndex, dutyIndex, 'htsDescription')
              //   )
              // }

            }
            if (!onLoad || (allEntryData?.mustBeEditable && allEntryData?.dutyIsEditable)) {
              let keepTrackOfAddingItems = 'addingMerch'+merchandiseId+'xx'+countryOfOrigin+"XX"+hts;
              let russiaTariffApplicable = russiaTarriffCodes.find(a=>hts.replace(/[\.]/g, '').trim().startsWith(a));
              if(((window[keepTrackOfAddingItems]||0)+5000) <Date.now()){
                window[keepTrackOfAddingItems]= Date.now()
                if(hsDataDtl.chinaTariffMetadata && countryOfOrigin === 'CN'){
                  let alreadyApplied = checkIfAlreadyApplied(hsDataDtl.chinaTariffMetadata, merchandiseId, merchandiseData, allEntryData?.entryDate?.epochs);
                  let similarExists = checkIfSimilarApplied(merchandiseData);
                  
                  const existingMatchingExclusion = (merchandiseData.merchandiseDuties ||[]).find(aaa=>allPossibleChinaExlcusionHTSTriggers().includes(aaa.htsus))
                  const commodityDutysHTS =     ((merchandiseData.merchandiseDuties||[]).find(duty=>duty.isCommodityDuty==1)?.htsus+"").trim().replaceAll(".","");
                  const doesntneedexclusionanymore = commodityDutysHTS && !getExclusionHTSES(allEntryData?.entryDate?.epochs).includes(commodityDutysHTS);
                  if(existingMatchingExclusion && doesntneedexclusionanymore){
                    const exclusionIndex = merchandiseData.merchandiseDuties.indexOf(existingMatchingExclusion);
  
                    dispatch(
                      updateMerchDutyItemFeild(
                        invoiceItemIndex,
                        lineItemIndex,
                        exclusionIndex,
                        'htsus',
                        (hsDataDtl?.chinaTariffMetadata?.htsNo || "9903").replaceAll(".","")
                      )
                    )
                    dispatch(
                      saveMerchDutyItem(lineItemIndex, invoiceItemIndex, exclusionIndex, 'htsus')
                    )
                  }

                   if(!alreadyApplied && !existingMatchingExclusion){
                    let createMerch = ()=>{
                      
                      createMerchandiseDutyItem(
                        invoiceItemIndex,
                        invoiceId,
                        merchandiseId,
                        lineItemIndex,
                        function(){},
                        hsDataDtl.chinaTariffMetadata.htsNo || "",
                        null,
                        hsDataDtl.chinaTariffMetadata
                      )
                    }
                    if(similarExists.appliedChinaDuty && allEntryData?.hsDtlCalledFrom=="htsus"){
                      dispatch(removeDutyItem(
                        merchandiseId,
                        [similarExists.merchandiseDutyId],
                        lineItemIndex,
                        invoiceItemIndex,
                        0,//unused
                        null,
                        store.getState()?.PSC?.pscShipmentId
                      ))
                      setTimeout(()=>{
                        createMerch();
                      },800);
                    } else {
                      createMerch();
                    }
                    
                  }
                }
                if(countryOfOrigin == "RU" && russiaTariffApplicable ){
                  if(!checkIfRussiaTarriffAlreadyApplied(merchandiseData)){
                    createMerchandiseDutyItem(
                      invoiceItemIndex,
                      invoiceId,
                      merchandiseId,
                      lineItemIndex,
                      function(){},
                      "99039008",
                      null,
                      {"htsNo": "99039008",
                      displayDescription:"RUSSIA COLUMN 2 INCREASE 3" }
                    )
                  }
                }
              }
              if(countryOfOrigin == "RU" && !russiaTariffApplicable && checkIfRussiaTarriffAlreadyApplied(merchandiseData)){
                let russiaExtraDuties = (merchandiseData?.merchandiseDuties || []).filter(a => a.isCommodityDuty == 2 && russiaAdditionalCostHTS.includes((a.htsus || "").replaceAll(".", "").trim()));
                setTimeout(() => {
                  dispatch(removeDutyItem(
                    merchandiseId,
                    russiaExtraDuties.map(oneduty => oneduty.merchandiseDutyId),
                    lineItemIndex,
                    invoiceItemIndex,
                    0,//unused
                    null,
                    store.getState()?.PSC?.pscShipmentId
                  ))

                }, 2502);

              }
            }
          } else {
            // Update fields applying to non-commodity HTS
            dispatch(
              updateHSDataDtl(
                hsDataDtl,invoiceItemIndex,
                lineItemIndex,
                dutyIndex
              )
            )
          }
          if (!onLoad) {
          
                
            if (hsDataDtl.displayDescription) {
              if ((myDutyCurrent.htsDescription||"").toLowerCase() != (hsDataDtl.displayDescription||"").toLowerCase()) {
                dispatch(
                  updateMerchDutyItemFeild(
                    invoiceItemIndex,
                    lineItemIndex,
                    dutyIndex,
                    'htsDescription',
                    hsDataDtl.displayDescription
                  )
                )
                dispatch(
                  saveMerchDutyItem(lineItemIndex, invoiceItemIndex, dutyIndex, 'htsDescription',undefined, hsDataDtl?.priorityNumber)
                )
              }
            }
            // If no dispalyDesc Update and Save HTS Description to _BLANK_
            // else if (!hsDataDtl.displayDescription) {
            //   dispatch(
            //     updateMerchDutyItemFeild(invoiceItemIndex,
            //       lineItemIndex,
            //       dutyIndex,
            //       'htsDescription',
            //       '_BLANK_'
            //     )
            //   )
            //   dispatch(
            //     saveMerchDutyItem(lineItemIndex, invoiceItemIndex, dutyIndex, 'htsDescription')
            //   )
            // }
          }

            dispatch(
              updateMerchDutyItemFeild(invoiceItemIndex,
                lineItemIndex,
                dutyIndex,
                'isValidHts',
                (errorCode !== 400 && errorCode !== 404)
              )
            )
        } else {
          // dispatch(updateMerchLineItemFeild(lineItemIndex, 'availableProductClaimCode', []))
          if(hsDataDtl.header.code == 400 || hsDataDtl.header.code == 404){
             dispatch(
                  updateMerchDutyItemFeild(invoiceItemIndex,
                    lineItemIndex,
                    dutyIndex,
                    'isValidHts',
                    false
                  )
                )
          }
          return dispatch(updateHSDataDtl({},invoiceItemIndex, lineItemIndex, dutyIndex))
          
        }
      })
      .catch(e => {
        console.log('Error getting hsDataDtl', e)
        return dispatch(updateHSDataDtl({},invoiceItemIndex, lineItemIndex, dutyIndex))
      })
      setTimeout(()=>
       {document.getElementById("VALIDATE_FORM_BUTTON") && document.getElementById("VALIDATE_FORM_BUTTON").click();}
      ,1500)
      setTimeout(()=>
       {document.getElementById("VALIDATE_FORM_BUTTON") && document.getElementById("VALIDATE_FORM_BUTTON").click();}
      ,5000)
  }
}

export function updateUserFee(lineItemIndex,invoiceItemIndex, dutyIndex, feeIndex, feeValue) {
  return (dispatch, getState) => {
    const additionalDuties = {};
    additionalDuties.userFees = getState().DescriptionOfMerchandise.entrySummaryInvoices[invoiceItemIndex].merchandiseLineItems[lineItemIndex].merchandiseDuties[dutyIndex].additionalDuties.userFees.slice();
    additionalDuties.userFees[feeIndex]["feeValue"] = feeValue;
    dispatch(
      updateMerchDutyItemFeild(
        invoiceItemIndex,lineItemIndex,
        dutyIndex,
        'additionalDuties',
        additionalDuties
      )
    )
  }
}

export function addUserFeeByList(lineItemIndex,invoiceItemIndex, dutyIndex, userFeeByList) {
  return (dispatch, getState) => {
    const additionalDuties = {};
    additionalDuties.userFees = userFeeByList.slice();

      
    dispatch(
      updateMerchDutyItemFeild(
        invoiceItemIndex,lineItemIndex,
        dutyIndex,
        'additionalDuties',
        additionalDuties
      )
    )
    dispatch(
      saveMerchDutyItem(lineItemIndex,invoiceItemIndex, dutyIndex, 'additionalDuties')
    )
  }
}

export function addUserFee(lineItemIndex,invoiceItemIndex, dutyIndex, userFee) {
  return (dispatch, getState) => {
    const additionalDuties = {};
    const additional_userFee = getState().DescriptionOfMerchandise.entrySummaryInvoices[invoiceItemIndex].merchandiseLineItems[lineItemIndex].merchandiseDuties[dutyIndex].additionalDuties.userFees || [];
    additionalDuties.userFees = additional_userFee.slice();
      // check to make sure you got value and fee doesnt exist yet for duty
      let userFeeCodes = getState().DropDownValues.userFeeCodes;
      let dutyFee = _.isObject(userFee) ? userFee.dutyType : userFee
      if (dutyFee && !userFeeCodes.find(fee => fee.stringVal === dutyFee)) {
        return null;
      }
      let userFees = '';
      if(_.isObject(userFee)){
        userFees = [];
        let existingFees = additionalDuties.userFees || [];
        if(existingFees.find(existingFee=>existingFee?.dutyType === userFee.dutyType)){
          userFees.push(existingFees.find(existingFee=>existingFee?.dutyType === userFee.dutyType))
        } else {
          userFees.push(userFee)
        }
      }else{
        let _index = additionalDuties.userFees.findIndex(fee => fee.dutyType === dutyFee);
        if(_index>-1){
          additionalDuties.userFees[_index]['disclaim'] = "0";
          userFees = additionalDuties.userFees;
        }else{
          if(additionalDuties.userFees && additionalDuties.userFees.length){
            additionalDuties.userFees.push({ dutyType: userFee, feeValue: '0.00', "isRequired":"2", "specificRate":"0.0","adValoremRate":"0.0","computationCode":"2", "disclaim":"0" })
            userFees = additionalDuties.userFees;
          }else{
            userFees = [];
            userFees.push({ dutyType: userFee, feeValue: '0.00', "isRequired":"2", "specificRate":"0.0","adValoremRate":"0.0","computationCode":"2", "disclaim":"0" })
          }
        }
      }
     /* let _index = additionalDuties.userFees.findIndex(fee => fee.dutyType === dutyFee);
      if(_index>-1){
         if(_.isObject(userFee)){
           additionalDuties.userFees[_index] = userFee;
          }
        additionalDuties.userFees[_index]['disclaim'] = "0";
      }
      else 
      {
        if(_.isObject(userFee)){
          additionalDuties.userFees.push(userFee)
        }else{
        additionalDuties.userFees.push({ dutyType: userFee, feeValue: '0.00', "disclaim":"0" })
      }
    }*/
    dispatch(
      updateMerchDutyItemFeild(
       invoiceItemIndex, lineItemIndex,
        dutyIndex,
        'additionalDuties',
        {
          userFees
        }
      )
    )
    dispatch(
      saveMerchDutyItem(lineItemIndex,invoiceItemIndex, dutyIndex, 'additionalDuties')
    )
  }
}

/*export function addUserFee(lineItemIndex, dutyIndex, userFee) {
  return (dispatch, getState) => {
    const additionalDuties = {};
    additionalDuties.userFees = getState().DescriptionOfMerchandise.merchandiseLineItems[lineItemIndex].merchandiseDuties[dutyIndex].additionalDuties.userFees.slice();
    // check to make sure you got value and fee doesnt exist yet for duty
    let userFeeCodes = getState().DropDownValues.userFeeCodes;
    if (!userFeeCodes.find(fee => fee.stringVal === userFee) || (additionalDuties.userFees.find(fee => fee.dutyType === userFee))) {
      return null;
    }
    additionalDuties.userFees.push({  
      dutyType: userFee,
      feeValue: (feeValue ? feeValue :'0.00')
    })
    dispatch(
      updateMerchDutyItemFeild(
        lineItemIndex,
        dutyIndex,
        'additionalDuties',
        additionalDuties
      )
    )
    dispatch(
      saveMerchDutyItem(lineItemIndex, dutyIndex, 'additionalDuties')
    )
  }
}*/
export function disclaimUserFee_dd(lineItemIndex, invoiceItemIndex ,dutyIndex, thisDutyType,oldval) {
  return (dispatch, getState) => {
    let lineItem = getState().DescriptionOfMerchandise.entrySummaryInvoices[invoiceItemIndex].merchandiseLineItems[lineItemIndex]
    let duty = lineItem.merchandiseDuties[dutyIndex]
    let merchandiseId = lineItem.merchandiseId;

    // Set new values
    const additionalDuties = {};
    additionalDuties.userFees = duty.additionalDuties.userFees.slice();
    let currentFee = additionalDuties.userFees.find((a)=>a.dutyType==thisDutyType);
    let userFeeIndex = additionalDuties.userFees.indexOf(currentFee);

    additionalDuties.userFees[userFeeIndex]['disclaim'] = oldval==1?2:1;
    if(oldval!=1){
      additionalDuties.userFees[userFeeIndex]['feeValue'] = "0";
    }
    dispatch(
      updateMerchDutyItemFeild(
      invoiceItemIndex,  lineItemIndex,
        dutyIndex,
        'additionalDuties',
        additionalDuties
      )
    )
    dispatch(saveMerchDutyItem(lineItemIndex,invoiceItemIndex, 0, 'additionalDuties'))
  }
}
export function excemptUserFee(lineItemIndex,invoiceItemIndex, dutyIndex, userFeeIndex) {
  return (dispatch, getState) => {
    let lineItem = getState().DescriptionOfMerchandise.entrySummaryInvoices[invoiceItemIndex].merchandiseLineItems[lineItemIndex]
    let duty = lineItem.merchandiseDuties[dutyIndex]
    let merchandiseId = lineItem.merchandiseId;

    // Set new values
    const additionalDuties = {};
    additionalDuties.userFees = duty.additionalDuties.userFees.slice();
    additionalDuties.userFees[userFeeIndex] = {};
    dispatch(
      updateMerchDutyItemFeild(
       invoiceItemIndex, lineItemIndex,
        dutyIndex,
        'additionalDuties',
        additionalDuties
      )
    )
    dispatch(saveMerchDutyItem(lineItemIndex,invoiceItemIndex, 0, 'additionalDuties'))
    // setTimeout(()=>{
    //   additionalDuties.userFees.splice(userFeeIndex, 1);
    //   // remove fee
    //   dispatch(
    //     updateMerchDutyItemFeild(
    //       lineItemIndex,
    //       dutyIndex,
    //       'additionalDuties',
    //       additionalDuties
    //     )
    //   ) 
    // }, 1000)
  }
}

export function removeUserFee(lineItemIndex,invoiceItemIndex, dutyIndex, userFeeIndex) {
  return (dispatch, getState) => {
    let lineItem = getState().DescriptionOfMerchandise.entrySummaryInvoices[invoiceItemIndex].merchandiseLineItems[lineItemIndex]
    let duty = lineItem.merchandiseDuties[dutyIndex]
    let merchandiseId = lineItem.merchandiseId;

    // Set new values
    const additionalDuties = {};
    additionalDuties.userFees = duty.additionalDuties.userFees.slice();
    let userFee = additionalDuties.userFees[userFeeIndex];
    additionalDuties.userFees.splice(userFeeIndex, 1);

    // remove fee
    dispatch(
      updateMerchDutyItemFeild(
       invoiceItemIndex, lineItemIndex,
        dutyIndex,
        'additionalDuties',
        additionalDuties
      )
    ) 
    // Determine if it needs to be deleted from totals
    let userFeeStillExists = false;
    let invoice = getState().DescriptionOfMerchandise.entrySummaryInvoices[invoiceItemIndex];
    getState().DescriptionOfMerchandise.entrySummaryInvoices[invoiceItemIndex].merchandiseLineItems.forEach(lineItem => {
      // Only need to look at commodity duty userFees (first duty item)
      let userFees = _.get(lineItem, 'merchandiseDuties[0].additionalDuties.userFees', []);
      userFees.forEach(fee => {
        if (userFee.dutyType === fee.dutyType) { // if you still find the fee in other duties, we want to keep it in the totals
          userFeeStillExists = true;
        }
      })
    })
    return deleteUserFee(merchandiseId, duty.merchandiseId, userFee.dutyType, userFeeStillExists,invoice.invoiceId, getState()?.PSC.pscShipmentId || getState()?.FormValues.shipmentId)///////////////////////////
      // .then(() => {
      //   dispatch(updateTotals());
      // })
      .catch(err => {
        console.log('err: ', err);
        // revert to previous state if error hit
        addUserFee(lineItemIndex,invoiceItemIndex, dutyIndex, userFee.feeValue);
        // dispatch(updateTotals());
        console.error('Error removing userFee', err)
      })
  }
}

// If Trade Aggreement || Country of Origin are changed, context for all HTS in line item changes
// Call HTS API to get new context and overwrite previous values for all HTS in line item
export function handleLineItemContextSwitch(lineItemIndex , invoiceItemIndex) {
  return (dispatch, getState) => {
    let modeOfTransport = getState().TransportationInfo.modeOfTransport
    let portOfUnlading = getState().TransportationInfo.USportOfUnladingCode.id
    let entryType = getState().EntryTypeInfo.entryType
    let summaryDate = entryTypeFields.summaryDate.getHSAPIValue(getState().EntryTypeInfo.summaryDate.epochs)
    let portEntry = getState().EntryTypeInfo.portCode.id
    let DescriptionOfMerchandise = getState().DescriptionOfMerchandise.entrySummaryInvoices[invoiceItemIndex]
    let tradeAgreement =
      DescriptionOfMerchandise.merchandiseLineItems[lineItemIndex]
        .productClaimCode
    let {countryOfOrigin, permitTypeCode, permitNumber} = DescriptionOfMerchandise.merchandiseLineItems[lineItemIndex]

    let hsList = []
    DescriptionOfMerchandise.merchandiseLineItems[lineItemIndex].merchandiseDuties.forEach((duty, dutyIndex) => {
      if (duty.htsus) {
        hsList.push(
          gethsDataDtlListBody({
            uiValue: 'N',
            itemId: `${lineItemIndex}-${dutyIndex}`,
            htsCode: formatHTS(duty.htsus),
            enteredValue:
              DescriptionOfMerchandise.merchandiseLineItems[lineItemIndex]
                .merchandiseDuties[0].enteredValue,
            tradeAgreement,
            modeOfTransport,
            entryType,
            portEntry,
            portOfUnlading,
            countryOfOrigin
          })
        )
      }
    })
    // getHSTotalDCT(hsList, summaryDate, HTS_DTL_CAL_MODES.details)
    //   .then(response => {
    //     // Update HTS info
    //     dispatch(
    //       updateHTSContext(
    //         buildHTSItemsToSave(response.data.eventMessage.hsDataDtlList)
    //       )
    //     )
    //     // Get new totals and update and save
    //     // dispatch(updateTotals())
    //     // Save LineItem that was udated due to context change
    //     //dispatch(saveLineItem(lineItemIndex))
    //   })
    //   .catch(e => {
    //     console.error('hts res error', e)
    //   })
  }
}

// If HTS || Entered Value are changed, context for HTS in the Duty item changes
// Call HTS API to get new context and overwrite previous values for HTS in duty item
export function handleDutyItemContextSwitch(lineItemIndex,invoiceItemIndex, dutyItemIndex) {
  console.log('handleDutyItemContextSwitch', lineItemIndex, dutyItemIndex)
  return (dispatch, getState) => {
    let duty = getState().DescriptionOfMerchandise.entrySummaryInvoices[invoiceItemIndex].merchandiseLineItems[
      lineItemIndex
    ].merchandiseDuties[dutyItemIndex]
    if (!duty.htsus) {
      return null
    }
    let modeOfTransport = getState().TransportationInfo.modeOfTransport
    let portOfUnlading = getState().TransportationInfo.USportOfUnladingCode.id
    let entryType = getState().EntryTypeInfo.entryType
    let summaryDate = entryTypeFields.summaryDate.getHSAPIValue(getState().EntryTypeInfo.summaryDate.epochs)
    let portEntry = getState().EntryTypeInfo.portCode.id
    let DescriptionOfMerchandise = getState().DescriptionOfMerchandise.entrySummaryInvoices[invoiceItemIndex]
    let tradeAgreement =
      DescriptionOfMerchandise.merchandiseLineItems[lineItemIndex]
        .productClaimCode
    let countryOfOrigin =
      DescriptionOfMerchandise?.merchandiseLineItems[lineItemIndex]
        .countryOfOrigin
    let hsList = [
      gethsDataDtlListBody({
        uiValue: 'N',
        itemId: `${lineItemIndex}-${dutyItemIndex}`,
        htsCode: formatHTS(duty.htsus),
        enteredValue:
          DescriptionOfMerchandise.merchandiseLineItems[lineItemIndex]
            .merchandiseDuties[0].enteredValue,
        tradeAgreement,
        modeOfTransport,
        entryType,
        portEntry,
        portOfUnlading,
        countryOfOrigin
      })
    ]
    // Update All

    // getHSTotalDCT(hsList, summaryDate, HTS_DTL_CAL_MODES.details)
    //   .then(response => {
    //     // Update HTS info
    //     dispatch(
    //       updateHTSContext(
    //         buildHTSItemsToSave(response.data.eventMessage.hsDataDtlList)
    //       )
    //     )
    //     // Get new totals and update and save
    //     // dispatch(updateTotals())
      
    //     // Save LineItem that was udated due to context change
    //     dispatch(saveDutyItem(lineItemIndex, dutyItemIndex))
    //   })
    //   .catch(e => {
    //     console.error('hts res error', e)
    //   })
  }
}

// Format hsDataDtlList from API so it can be ingested by reducer easily
// const buildHTSItemsToSave = hsDataDtlList => {
//   console.log("food!!!!!!",hsDataDtlList)
//   return hsDataDtlList.map(item => ({
//     lineItemIndex: item.itemId.split('-')[0],
//     dutyIndex: item.itemId.split('-')[1],
//     vals: {
//       mpf: { fee: parseFloat(item.mpfVal).toFixed(2) },
//       hmf: { fee: parseFloat(item.hmfVal).toFixed(2) },
//       duty: parseFloat(item.duty).toFixed(2),
//       dutyRate: parseFloat(item.dutyRate).toFixed(2)
//     }
//   }))
// }

// Sums up raw totals from all line/duty items and then calls API with
// raw totals to get the translated totals that are then saved to the store/backend
// export function updateTotals() {
//   return (dispatch, getState) => {
//     let totals = calculateNewTotals(
//       getState().DescriptionOfMerchandise.merchandiseLineItems
//     )
//     let summaryDate = entryTypeFields.summaryDate.getHSAPIValue(getState().EntryTypeInfo.summaryDate.epochs)
//     getHSTotalDCT(
//       null,
//       summaryDate,
//       HTS_DTL_CAL_MODES.summary,
//       totals.hmf.fee,
//       totals.mpf.fee,
//       totals.duty,
//       totals.tax,
//       totals.totalUserFees
//     )
//       .then(response => {
//         dispatch(
//           updateAndSaveTotals(
//             response.data.eventMessage.totHMF,
//             response.data.eventMessage.totMPF,
//             response.data.eventMessage.totDuty,
//             response.data.eventMessage.totUser,
//             response.data.eventMessage.totTax,
//             totals.additionalDuties,
//           )
//         )
//       })
//       .catch(e => {
//         console.error('Error setting totals', e)
//       })
//   }
// }

// Saves all the Duties for a Line Item (fields pertaining to context switch at line item level)
export function saveLineItem(lineItemIndex) {
  return (dispatch, getState) => {
    saveLineItemDuties(getState().DescriptionOfMerchandise, lineItemIndex)
  }
}

// Saves dependent fields for a duty item if its context is changed
export function saveDutyItem(lineItemIndex, dutyIndex) {
  return (dispatch, getState) => {
    let lineItem = getState().DescriptionOfMerchandise.merchandiseLineItems[
      lineItemIndex
    ];
    let duty = lineItem.merchandiseDuties[dutyIndex]
    let fields = {
      duty: duty.duty,
      dutyRate: duty.dutyRate,
      htsus: duty.htsus.replace(/[\.]/g, '')
    }
    if (duty.isCommodityDuty === 1) {
      fields.mpf = duty.mpf
      fields.hmf = duty.hmf
    }

    
    let doesntWorkForInvoiceCurrencyValue = !Object.keys(fields).includes("invoiceCurrencyValue");
    if( hasDutyOverride(duty,lineItem["merchandiseDuties"]) && doesntWorkForInvoiceCurrencyValue){
      fields['dutyOverrideFlag'] =duty.dutyOverrideFlag;
    }

    saveDescriptionOfMerchandiseDutyItem(
      getState().DescriptionOfMerchandise.merchandiseLineItems[lineItemIndex]
        .merchandiseId,
      duty.merchandiseDutyId,
      fields,
      duty.isCommodityDuty
    )
      .then(res => { })
      .catch(e => console.log('Error saving Duty Item fields'))
  }
}

export function updateTheseFieldsTotals(
  objWithEveryThing,
  additionalData) {
    return (dispatch, getState) => {
      console.log('myfields: ', 
      {objWithEveryThing,
      additionalData});
      dispatch({
        type: actionTypes.UPDATE_THESE_FIELDS_TOTALS,
        objWithEveryThing,
        additionalData
        
      })
    }
  
  }

export function updateAndSaveTotals(newHMF, newMPF, newDuty, newFee, newTax, 
  additionalDuties,
  bondedAdDutyAmt,
  bondedCvdDutyAmt,
  cashAdDutyAmt,
  cashCvdDutyAmt,
  grandTotal,
  objWithEveryThing
  
  ) {
    let otherTotalsVals_pq=objWithEveryThing;

    //hts query update from backend

  return (dispatch, getState) => {
    let hmf = {
      fee: parseFloat(newHMF).toFixed(2)
    }
    let mpf = {
      fee: parseFloat(newMPF).toFixed(2)
    }
    let fee = parseFloat(newFee).toFixed(2)
    let duty = parseFloat(newDuty).toFixed(2)
    let tax = parseFloat(newTax).toFixed(2)

    grandTotal = parseFloat(grandTotal).toFixed(2)
    let other = parseFloat(otherTotalsVals_pq.other).toFixed(2) 
    // Update store with values
    let myfields = {
      
      duty,
      fee,
      tax,
      grandTotal,
      other,
      mpf,
      hmf,
      additionalDuties,
      bondedAdDutyAmt,
      bondedCvdDutyAmt,
      cashAdDutyAmt,
      cashCvdDutyAmt,
      otherTotalsVals_pq
    };
    //console.log('myfields: ', myfields);
    dispatch({
      type: actionTypes.UPDATE_TOTALS,
      fields: myfields
      
    })
    // Save values
    // saveTotals(duty, fee, grandTotal, hmf.fee, mpf.fee, tax, additionalDuties)
  }
}

export function handleHTSOverRide(lineItemIndex, dutyItemIndex) { }

// Updates HTS Data Dtl information from API, saves all DTLs to be used and specificically availableProductClaimCode to filter Trade Agreements
export function updateHSDataDtl(hsDataDtl,invoiceItemIndex, lineItemIndex, dutyIndex) {

  // Get array of possible codes allowed for the given HTS (It is not valid JSON)
  let availableCodes = (_.get(hsDataDtl, 'specialProgramCodes', '[]')).split(',')
  let tradeProgramDetails = (_.get(hsDataDtl, 'tradeProgramDetails', '[]'))
  let permitTypeCodeFromApi = (_.get(hsDataDtl, 'permitTypeCode', ""))
  let excludedCountriesGsp = (_.get(hsDataDtl, "excludedCountriesGsp", ''))
  if(excludedCountriesGsp){
    excludedCountriesGsp = excludedCountriesGsp.split(","); 
  }
  
  let countryWise = store.getState().DropDownValues.tradeProgramCountryMapping;
  let DescriptionOfMerchandise = store.getState().DescriptionOfMerchandise.entrySummaryInvoices[invoiceItemIndex];
  let merchandiseLine = DescriptionOfMerchandise?.merchandiseLineItems[lineItemIndex];
  let countryOfOrigin = merchandiseLine ? merchandiseLine?.countryOfOrigin: "";
  // Build list of availableProductClaimCode by filting splProgramList with available specialProgramCodes from hsDataDtl
  let splPrgList = store.getState().DropDownValues.splProgramList;
  let availableProductClaimCode = splPrgList.filter(code => Boolean(availableCodes.find((specialProgramCodes) => specialProgramCodes === code.id)))
  
  if(countryOfOrigin){
    availableProductClaimCode = availableProductClaimCode.filter((item)=>{
      if(countryWise[item.id]){
        let applicableCountries = countryWise[item.id].applicableCountries;
        if(excludedCountriesGsp && excludedCountriesGsp.length){
          applicableCountries = applicableCountries.filter( function( el ) {
            return excludedCountriesGsp.indexOf( el ) < 0;
          });
        }
        return applicableCountries.includes(countryOfOrigin) || item.id === 'NONE'
      }else{
        return item.id === 'NONE'
      }
    })
  }
  
  // Also add NONE option to the beginning
  availableProductClaimCode.unshift({
    id: 'NA',
    description: 'Not Applicable',
    ediCode: 'NA'
  })
  
  if(!countryOfOrigin){
    availableProductClaimCode =[];
  }
  
  return {
    type: 'SET_HS_DATA_DTL',
    payload: hsDataDtl,
    availableProductClaimCode,
    availableCodes,
    tradeProgramDetails,
    permitTypeCodeFromApi,
    excludedCountriesGsp,
    invoiceItemIndex,
    lineItemIndex,
    dutyIndex
  }
}
 export function updateTradeAgreementListOnCountryChange(lineItemIndex,invoiceItemIndex, countryOfOrigin){
   
    return {
      type: "UPDATE_TRADE_AGREEMENT_ON_COUNTRY_CHANGE",
      lineItemIndex,
      invoiceItemIndex,
      countryOfOrigin,
      "tradeProgramCountryMapping": store.getState().DropDownValues.tradeProgramCountryMapping || [],
      "splProgramList": store.getState().DropDownValues.splProgramList || [],
      "tradeProgramDetails": store.getState().DescriptionOfMerchandise.entrySummaryInvoices[invoiceItemIndex].merchandiseLineItems[lineItemIndex].tradeProgramDetails || []
    }
 }

 export function updateDutyRateOnTradeAgreementChange(lineItemIndex,invoiceItemIndex, dutyIndex, tradeAgreementSelected) {
  let DescriptionOfMerchandise = store.getState().DescriptionOfMerchandise.entrySummaryInvoices[invoiceItemIndex]; 
  return {
    type: "UPDATE_DUTY_RATE_ON_TRADE_AGREEMENT_CHANGE",
    lineItemIndex,
    dutyIndex,
    invoiceItemIndex,
    tradeAgreementSelected,
    "tradeProgramDetails": DescriptionOfMerchandise.merchandiseLineItems[lineItemIndex].tradeProgramDetails
  }
 }
 
// Passes HTS Items to reducer that will update appropaite duty items
export function updateHTSContext(htsItems) {
  return {
    type: actionTypes.UPDATE_HTS_CONTEXT,
    htsItems: htsItems
  }
}

export function updateMerchFeild(field, payload) {
  return {
    type: actionTypes.UPDATE_MERCH_FIELD,
    payload,
    field
  }
}

export function updateAVCDVDField(field, payload, saveafterwards,lineItemIndex,invoiceItemIndex ,shipmentId, merchandiseId) {
  return {
    type: actionTypes.UPDATE_HAS_AVCVD(merchandiseId),
    payload,
    field,
    saveafterwards,
    lineItemIndex,
    invoiceItemIndex,
    shipmentId,
    merchandiseId,
  }
}

export function updateMerchObject(object, field, payload) {
  return {
    type: actionTypes.UPDATE_MERCH_OBJECT,
    payload,
    field,
    object
  }
}

export function updateMerchLineItemFeild(index,invoiceItemIndex, field, payload) {
  return {
    type: actionTypes.UPDATE_MERCH_LINE_ITEM_FIELD,
    payload,
    field,
    index,
    invoiceItemIndex
  }
}

export function updateMerchLineItemObject(index,invoiceItemIndex, object, field, payload) {
  return {
    type: actionTypes.UPDATE_MERCH_LINE_ITEM_OBJECT,
    payload,
    field,
    object,
    index,
    invoiceItemIndex
  }
}

export function updateMerchLineItemPgaFlagsNoSave(merchandiseId, pgaGuid, payload ) {
 return {
    type: actionTypes.UPDATE_MERCH_LINE_ITEM_FLAG,
    merchandiseId, 
    payload,
    pgaGuid
  }
}


export function updateMerchLineItemPgaObject(merchandiseId, field, payload  , lineItemIndex ,invoiceItemIndex, formType, pgaGuid ) {
  if(field && field.indexOf("Flag")>=1 && payload==1){
    if(document.getElementsByClassName("formContentarea_bc")?.length && document.getElementById(`pgaanchorll${pgaGuid}`)){
      document.getElementsByClassName("formContentarea_bc")[0].scrollTop +=  
      document.getElementById(`pgaanchorll${pgaGuid}`).getBoundingClientRect().top - 400;
    }
  }
  return {
    type: actionTypes.UPDATE_MERCH_LINE_ITEM_PGA_OBJECT,
    merchandiseId,
    field,
    payload  , lineItemIndex ,invoiceItemIndex 
    ,formType, pgaGuid
  }
}

export function updateMerchDutyItemFeild(
  invoiceItemIndex,
  lineItemIndex,
  dutyIndex,
  field,
  payload,
  merchandiseId
) {
  return {
    type: actionTypes.UPDATE_MERCH_DUTY_ITEM_FIELD,
    payload,
    field,
    lineItemIndex,
    invoiceItemIndex,
    dutyIndex,
    merchandiseId
  }
}

export function updateMerchDutyItemObject(
  lineItemIndex,invoiceItemIndex,
  dutyIndex,
  object,
  field,
  payload
) {
  return {
    type: actionTypes.UPDATE_MERCH_DUTY_ITEM_OBJECT,
    payload,
    lineItemIndex,
    dutyIndex,
    object,
    field,invoiceItemIndex
  }
}

export function addDutyItem(invoiceItemIndex,  merchIndex, newDuty) {
  return {
    type: actionTypes.ADD_DUTY_ITEM,
    merchIndex,
    newDuty,
    invoiceItemIndex
  }
}

export function removeDutyItemsNoApi(invoiceId,  merchandiseId, arrayOfDutyIdsToRemove) {
  return {
    type: actionTypes.REMOVE_DUTY_ITEMS_NO_API,
    invoiceId,  merchandiseId, arrayOfDutyIdsToRemove
  }
}

export function updateArticleSubComponent(articleSetId, merchandiseId , invoiceItemIndex) {
  return {
    type: 'UPDATE_ARTICLE_SUBCOMPONENT',
    articleSetId,
    merchandiseId, 
    invoiceItemIndex
  }
}

export function addMerchandiseLineItem(invoiceItemIndex ,newLineItem) {
  return {
    type: actionTypes.ADD_MERCHANDISE_LINE_ITEM,
    newLineItem,
    invoiceItemIndex
  }
}

export function removeDutyItem(
  merchandiseId,
  merchandiseDutyIdArray,
  merchIndex,invoiceItemIndex,
  dutyIndex,
  deleteHtsStatus,
  pscShipId
) {
  return (dispatch, getState) => {
    let invoiceId = getState().DescriptionOfMerchandise.entrySummaryInvoices[invoiceItemIndex].invoiceId
    let iii = 0;
    for (let merchandiseDutyId of merchandiseDutyIdArray) {
      setTimeout(() => {
        deleteDuty(
          invoiceId,
          merchandiseId,
          merchandiseDutyId,
          pscShipId
        )
          .then(response => {
            //console.log('Delete Duty Item', response)
            response.data.eventMessage.hasOwnProperty("requestId") === true && alert('You deleted an entity which is causing improbable invoice values. Freight deductions are reset to zero, please make sure to re-enter probable values before final review.')
            dispatch({
              type: actionTypes.REMOVE_DUTY_ITEM,
              merchIndex,
              merchandiseDutyId,
              invoiceItemIndex
            })
            // dispatch(updateTotals())
            deleteHtsStatus && deleteHtsStatus()
          })
          .catch(error => {
            console.log(`Error from axios on FIELD set: `, error)
          })
      }, iii * 300)
      iii++;
    }
  }
}

export function removeMerchandiseLineItem(
  merchandiseId,invoiceItemIndex,
  merchIndex,
  updateStatus,
  articleSetId,
  articleHeader,
  articleSubComponent,
  pscShipId
) {
  return (dispatch, getState) => {
    let invoiceId = getState().DescriptionOfMerchandise.entrySummaryInvoices[invoiceItemIndex].invoiceId
    deleteMerchandise(invoiceId ,merchandiseId, merchIndex, updateStatus, articleSetId, pscShipId )
      .then(response => {
        response.data.eventMessage.hasOwnProperty("requestId")=== true &&  alert('You deleted an entity which is causing improbable invoice values. Freight deductions are reset to zero, please make sure to re-enter probable values before final review.')
        updateStatus()
        dispatch({
          type: 'REMOVE_MERCHANDISE_LINE_ITEM',
          index: merchIndex,
          invoiceItemIndex,
          merchandiseId,
          articleSetId,
          articleHeader,
          articleSubComponent
        })//action.UPDATETOTALS is taking care oif it 
    //    updateOnAddAndDeleteLineItem(response, merchIndex,invoiceItemIndex, 0, dispatch);
        // dispatch(updateTotals())
        dispatch(updateTotalValueAndGrossWeight())
        // dispatch(updateLineItemWeightsBasedonTotalValueAndGrossWeight())
      })
      .catch(error => {
        console.log(`Error from axios on FIELD set: `, error)
      })
  }
}

export function removeInvoiceLineItem(
  invoiceId,
  
  updateStatus
) {
  return (dispatch, getState) => {
    deleteInvoice(invoiceId)
      .then(response => {
        console.log('Delete Invoice Line', response)
      
        dispatch({
          type: actionTypes.REMOVE_INVOICE_LINE_ITEM,
          invoiceId,
          
        })
     

       dispatch(updateTotalValueAndGrossWeight())
       updateStatus()
      
      })
      .catch(error => {
        console.log(`Error from axios on FIELD set: `, error)
        updateStatus()
      })
  }
}

// Save
export function saveMerchandiseField(field) {
  return {
    type: actionTypes.SAVE_MERCHANDISE_FIELD,
    field
  }
}

export function saveDescriptionOfMerchandiseLine(merchandiseIndex,invoiceItemIndex, field, newValueQ) {
  return {
    type: actionTypes.SAVE_MERCHANDISE_LINE_ITEM,
    field,
    index: merchandiseIndex,
    invoiceItemIndex,
    newValueQ
  }
}

export function clearDescriptionOfMerchandiseLine(merchandiseIndex, invoiceItemIndex ,  field) {
  return {
    type: actionTypes.CLEAR_MERCHANDISE_LINE_ITEM,
    field,
    index: merchandiseIndex,
    invoiceItemIndex
  }
}

export function saveWholeInvoice(invoiceItemIndex,field){
  return (dispatch, getState) => {
    let invoiceId = getState().DescriptionOfMerchandise.entrySummaryInvoices[invoiceItemIndex].invoiceId
  
    let merchandiseItemList = []
    for(let lineitemx of getState().DescriptionOfMerchandise.entrySummaryInvoices[invoiceItemIndex].merchandiseLineItems){
      let allDutyItemList = [];
      for(let oneduty of lineitemx["merchandiseDuties"]){
        let oneArrayItemfieldsToSave = {};

        oneArrayItemfieldsToSave.merchandiseDutyId = oneduty.merchandiseDutyId
        if(_.isArray(field)){
          field.forEach((item)=>{
            oneArrayItemfieldsToSave[item] = oneduty[item]
          })
        }else{
          let value = oneduty[field]
          oneArrayItemfieldsToSave = {
            [field]: value
          }
        }
        allDutyItemList.push(oneArrayItemfieldsToSave)
      }
      merchandiseItemList.push({
        merchandiseId     : lineitemx.merchandiseId,
        articleSetId      : lineitemx.articleSetId,
        merchandiseDuties : allDutyItemList
      })
    }
    console.log('oneArrayItemfieldsToSave: ', merchandiseItemList);
    return saveDescriptionOfMerchandiseDutyItemArray(invoiceId, merchandiseItemList).then((res)=>{
      if(field=="enteredValue" && res && res.data.eventMessage.code === 400  && res.data.eventMessage.msg.trim()==="improbable value"){
        let errorMsg = []
        errorMsg.push("Total invoice cannot be less than total freight adjustment amount")
        let updatedEnteredValue =0.00
         dispatch(displayErrorMsgForEnterValue(-1,invoiceItemIndex, -1,field ,errorMsg,updatedEnteredValue, dispatch))
      }
      //action.UPDATETOtals is taking care of it 
    //  updateOnAddAndDeleteLineItem(res, lineItemIndex, invoiceItemIndex , dutyIndex, dispatch)
    })
  }
}


export function saveMerchDutyItem(lineItemIndex,invoiceItemIndex, dutyIndex, field, newxValue, priorityNumber,callback,actualField) {
  const isTarget = window.location.href.includes("target")
  
  return (dispatch, getState) => {
    let invoiceItem = getState().DescriptionOfMerchandise.entrySummaryInvoices[invoiceItemIndex];
    let lineItem = invoiceItem?.merchandiseLineItems[lineItemIndex];
    let duty = lineItem["merchandiseDuties"][dutyIndex];
    const baseHts = lineItem.merchandiseDuties.find((item)=>item.isCommodityDuty===1);
    // Get Value trying to be saved
    let fieldsToSave = {}
    if(_.isArray(field)){
      const usenewxValue = newxValue?.length && newxValue?.length == field?.length;
      field.forEach((item, itemIdxx)=>{
        fieldsToSave[item] = usenewxValue?newxValue[itemIdxx]:duty[item]
      })
    }else{
          // remove decimal value for enteredValue
       let value =  newxValue || duty[field]
      // Add it to field object that will be saved with totals
      fieldsToSave = {
        [field]: value
      }
    }
   
    if (field === 'htsus') {
      // If you are saving HTS, remove all '.'
      fieldsToSave[field] = fieldsToSave[field]?.replace(/[\.]/g, '')
    }
    if (field === 'irInfo') {
      fieldsToSave['IRTax']= duty.IRTax;
    }
     
    let doesntWorkForInvoiceCurrencyValue = !Object.keys(fieldsToSave).includes("invoiceCurrencyValue");
    if( hasDutyOverride(duty,lineItem["merchandiseDuties"]) && doesntWorkForInvoiceCurrencyValue){
      
      fieldsToSave['dutyOverrideFlag'] =duty.dutyOverrideFlag;
    }
    const additionalLineItemFields = {targetExtraData: lineItem?.targetExtraData}
     const grossAsEntered=field === "enteredValue" && actualField=="enteredValue"
     if((field === "enteredValue" &&  actualField=="invoiceCurrencyValue") || grossAsEntered){
      fieldsToSave.enteredValue =Math.round(duty?.enteredValue)
      fieldsToSave.invoiceCurrencyValue = duty?.invoiceCurrencyValue
      if(isTarget)
      fieldsToSave.invoiceQuantity = duty?.invoiceQuantity
  }
    if(isTarget){
      
    if(field === "unitPrice"){
      fieldsToSave.invoiceQuantity = duty?.invoiceQuantity
      fieldsToSave.enteredValue = Math.round(duty?.enteredValue)
      fieldsToSave.invoiceCurrencyValue = duty?.invoiceCurrencyValue
      
    }
    else if(field === "invoiceQuantity"){
      fieldsToSave.unitPrice = duty?.unitPrice
      fieldsToSave.enteredValue = Math.round(duty?.enteredValue)
      fieldsToSave.invoiceCurrencyValue = duty?.invoiceCurrencyValue
    }

   
   
  }
    return saveDescriptionOfMerchandiseDutyItem(
      getState().DescriptionOfMerchandise.entrySummaryInvoices[invoiceItemIndex].merchandiseLineItems[lineItemIndex]
        .merchandiseId,
        getState().DescriptionOfMerchandise.entrySummaryInvoices[invoiceItemIndex].invoiceId,
      duty.merchandiseDutyId,
      {...fieldsToSave, priorityNumber},
      duty.isCommodityDuty,
      lineItem.articleSetId,
      additionalLineItemFields
    ).then((res)=>{
      console.log(res ,"response")
      if(field=="enteredValue" && res.data.eventMessage.code === 400  && res.data.eventMessage.msg.trim()==="improbable value"){
        let errorMsg = []
        errorMsg.push("Total invoice cannot be less than total freight adjustment amount")
        let updatedEnteredValue =0.00
         dispatch(displayErrorMsgForEnterValue(lineItemIndex,invoiceItemIndex, dutyIndex,field ,errorMsg,updatedEnteredValue, dispatch))
      }
      if(isTarget){
      let invoice = res?.data?.eventMessage?.descriptionOfMerchandise?.entrySummaryInvoices.find((inv)=>inv.invoiceId===invoiceItem.invoiceId);
      let line = invoice?.merchandiseLineItems?.find((mline)=>mline?.merchandiseId===lineItem?.merchandiseId);
      const dutyLine = line?.merchandiseDuties?.find((item)=>item?.merchandiseDutyId===duty?.merchandiseDutyId);
       if(!dutyLine)
           return
        if(field === "invoiceCurrencyValue"){
          dispatch(
            updateMerchDutyItemFeild(
            invoiceItemIndex,
            lineItemIndex,
            dutyIndex,
            "unitPrice",
            (dutyLine?.unitPrice)
          ));
          dispatch(
            updateMerchDutyItemFeild(
            invoiceItemIndex,
            lineItemIndex,
            dutyIndex,
            "invoiceCurrencyValue",
            (dutyLine?.invoiceCurrencyValue)
          ));
          dispatch(
            updateMerchDutyItemFeild(
            invoiceItemIndex,
            lineItemIndex,
            dutyIndex,
            "enteredValue",
            (dutyLine?.enteredValue)
          ));
          dispatch(
            updateMerchDutyItemFeild(
            invoiceItemIndex,
            lineItemIndex,
            dutyIndex,
            "adjustedValue",
            (dutyLine?.adjustedValue)
          ));
      }
      else if(field === "unitPrice"){
        dispatch(
          updateMerchDutyItemFeild(
          invoiceItemIndex,
          lineItemIndex,
          dutyIndex,
          "invoiceCurrencyValue",
          (dutyLine?.invoiceCurrencyValue)
        ));
        callback && callback(dutyLine?.invoiceCurrencyValue)
        dispatch(
          updateMerchDutyItemFeild(
          invoiceItemIndex,
          lineItemIndex,
          dutyIndex,
          "enteredValue",
          (dutyLine?.enteredValue)
        ));
        dispatch(
          updateMerchDutyItemFeild(
          invoiceItemIndex,
          lineItemIndex,
          dutyIndex,
          "adjustedValue",
          (dutyLine?.adjustedValue)
        ));
      }
      else if(field === "invoiceQuantity"){
        dispatch(
          updateMerchDutyItemFeild(
          invoiceItemIndex,
          lineItemIndex,
          dutyIndex,
          "invoiceCurrencyValue",
          (dutyLine?.invoiceCurrencyValue)
        ));
        callback && callback(dutyLine?.invoiceCurrencyValue)
        dispatch(
          updateMerchDutyItemFeild(
          invoiceItemIndex,
          lineItemIndex,
          dutyIndex,
          "enteredValue",
          (dutyLine?.enteredValue)
        ));
      
             dispatch(
          updateMerchDutyItemFeild(
          invoiceItemIndex,
          lineItemIndex,
          dutyIndex,
          "adjustedValue",
          (dutyLine?.adjustedValue)
        ))
         
      }
      else if (actualField==="invoiceCurrencyValue"){
        callback && callback(dutyLine?.enteredValue)
      }
      else{}
    }
      if(fieldsToSave?.charges){
        dispatch(updateTheseFieldsTotals(
          res.data.eventMessage,
          {
            shipment_AAA: ["charges", "totalCharges"],
            invoice_AAA: ["charges", "totalCharges"],
            merchandise_AAA: ["charges", "totalCharges"],
          }

        ));
      }
      //action.UPDATETOtals is taking care of it 
    //  updateOnAddAndDeleteLineItem(res, lineItemIndex, invoiceItemIndex , dutyIndex, dispatch)
    })
    .catch(e => console.error('Error saving duty fields', field, e))
  }
}

export function displayErrorMsgForEnterValue(lineItemIndex,invoiceItemIndex, dutyIndex,field ,errorMsg, updatedEnteredValue,dispatch){
 

  return {
       type : "DISPLAY_ERROR_MSG_ENTERED_VALUE" , errorMsg , updatedEnteredValue , lineItemIndex , invoiceItemIndex , dutyIndex , field
  }
}

function updateOnAddAndDeleteLineItem(res, lineItemIndex,invoiceItemIndex, dutyIndex, dispatch){
  let data = res.data.eventMessage;
      if(data){
        let dom = data.descriptionOfMerchandise.entrySummaryInvoices[invoiceItemIndex]
        if(dom){
          let lineItems =  dom.merchandiseLineItems;
          lineItems.map((item ,index)=>{
            if(item["merchandiseDuties"]){
              let merchandiseDuty = item["merchandiseDuties"][dutyIndex];
              let newDuty = merchandiseDuty.duty;
              let newMpf = merchandiseDuty.mpf;
              let newHmf = merchandiseDuty.hmf;
              let enteredValue = merchandiseDuty.enteredValue;
              let additionalDuties = merchandiseDuty.additionalDuties;
              additionalDuties && dispatch(updateMerchDutyItemFeild(invoiceItemIndex,index, dutyIndex, 'additionalDuties', additionalDuties, item.merchandiseId));
              dispatch(updateMerchDutyItemFeild(invoiceItemIndex,index, dutyIndex, 'duty', newDuty, item.merchandiseId));
              newMpf && dispatch(updateMerchDutyItemFeild(invoiceItemIndex,index, dutyIndex, 'mpf', newMpf, item.merchandiseId));
              newHmf && dispatch(updateMerchDutyItemFeild(invoiceItemIndex,index, dutyIndex, 'hmf', newHmf, item.merchandiseId));
              enteredValue && dispatch(updateMerchDutyItemFeild(invoiceItemIndex,index, dutyIndex, 'enteredValue', enteredValue, item.merchandiseId));
            }
          })
        } 
  }
}
export function saveMerchDutyItemTotals(lineItemIndex, dutyIndex, field) {
  return {
    type: actionTypes.SAVE_MERCH_DUTY_ITEM_TOTALS,
    field,
    lineItemIndex,
    dutyIndex
  }
}

export function saveMerchCommodityDutyItem(lineItemIndex, field) {
  return {
    type: actionTypes.SAVE_MERCH_COMMODITY_DUTY_ITEM,
    field,
    lineItemIndex
  }
}

export function setMerchandiseLineItemAvailablePGA(pga) {
  return {
    type: actionTypes.SET_MERCHANDISE_LINE_ITEM_AVAILABLE_PGA,
    payload: pga
  }
}

export function updateTotalValueAndGrossWeight() {
  return (dispatch, getState) => {
    dispatch({
      type:
        actionTypes.SET_TOTAL_VALUE_AND_GROSS_WEIGHT
    })
  //  dispatch(saveMerchandiseField('totalValue'))
  }
}

export function updateLineItemWeightsBasedonTotalValueAndGrossWeight() {
  return dispatch => {
    dispatch({
      type:
        actionTypes.UPDATE_LINE_ITEM_WEIGHTS_BASED_ON_TOTAL_VALUE_AND_GROSS_WEIGHT
    })
    dispatch(updateTotalValueAndGrossWeight())
  }
}

export function setLineItem(lineItemIndex, lineItem) {
  return {
    type: actionTypes.SET_LINE_ITEM,
    lineItemIndex,
    lineItem
  }
}

export function createPGA(lineItemIndex) {
  return {
    type: actionTypes.ADD_ADDITIONAL_PGA,
    lineItemIndex
  }
}
// export function selectPGARedux(lineItemIndex,invoiceItemIndex , merchandiseId, formType, selectedPgaIndex, pgaOptions,
//     pgaHashAdditionalData
//   ) {
//   return {
//     type: 'SELECT_PGA',
//     lineItemIndex,
//     merchandiseId,
//     formType,
//     selectedPgaIndex,
//     pgaOptions,
//     invoiceItemIndex,
//     currentTimeOfRequest: Date.now(),
//     pgaHashAdditionalData
//   }
// }


export function updateInvoiceLineItemFeild(index, field, payload) {
  return {
      type: actionTypes.UPDATE_INVOICE_LINE_ITEM_FIELD,
      payload,
      field,
      index
  }
}

export function saveInvoiceLineItemFeild(index, field) {
  return {
    type: actionTypes.SAVE_INVOICE_LINE_ITEM,
    field,
    invoiceItemIndex: index,
    
  }
}


export function saveInvoiceLineItemFeildFrightData(index, field1,field2, field3 ) {

  return {
    type: actionTypes.SAVE_INVOICE_LINE_ITEM_FRIEGHT_DATA,
    field1,field2,field3,
    invoiceItemIndex: index,
    
  }
}


         
  export function createInvoiceLineItem(newInvoiceItem) {
    return {
      type: actionTypes.ADD_INVOICE_ITEM,
      newInvoiceItem,
      
    }
  }
    
       


export function removeFrieghtLevelDetails(invoiceItemIndex) {
  return (dispatch , getState) => {

// need to check
    dispatch(updateInvoiceLineItemFeild(
      invoiceItemIndex,
      "frieghtCharges",
      ""
    )); 


    dispatch(updateInvoiceLineItemFeild(
      invoiceItemIndex,
      "frieghtInsurance",
      ""
    )); 
 

    dispatch(updateInvoiceLineItemFeild(
      invoiceItemIndex,
      "otherCharges",
      ""
    )); 
  

    dispatch(updateInvoiceLineItemFeild(
      invoiceItemIndex,
      "totalEnteredValue",
      ""
    )); 
    dispatch( saveInvoiceLineItemFeildFrightData(
      invoiceItemIndex,
    "frieghtCharges" ,"otherDeductions" ,"frieghtInsurance"

    ))

  

  }
}






export function dispalyLoader(invoiceItemIndex) {
  return {
    type : "SHOW_LOADER",
    invoiceItemIndex
  }
}

export function hideExpandLoader(invoiceItemIndex){
  return {
    type : "HIDE_LOADER",
    invoiceItemIndex
  }
}

export function hideUnhideInvoiceItem(invoiceItemIndex){
  return {
    type : "HIDE_UNHIDE_INVOICE",
    invoiceItemIndex
  }
}

export function closeInvoiceItem(invoiceItemIndex){

  return {
    type : "HIDE_INVOICE",
    invoiceItemIndex
  }
}

const getHtsMetadata = async (tariffs, state) => {
  const metaDataList = [];

  for (const hts of tariffs) {
    const data = {
      eventMessage: {
        country: 'US',
        htsCode: hts,
        eta: state?.EntryTypeInfo?.entryDate?.epochs,
      },
      eventType: 'GET_HTS_METADATA',
      eventTime: Date.now(),
    };

    const response = await HttpClient.custom({ data });
    metaDataList.push(response?.data.eventMessage);
  }

  return metaDataList;
};

const deleteAdditionalHts = async (payload, shipmentId) => {
  const promises = payload.additionalHts.map((item) => {
    const data = {
      eventType: 'DELETE_ENTRY_SUMMARY_ENTITY',
      eventTime: Date.now(),
      eventMessage: {
        shipmentId: shipmentId,
        descriptionOfMerchandise: {
          entrySummaryInvoices: [
            {
              invoiceId: payload?.invoiceId,
              merchandiseLineItems: [
                {
                  shipmentId: shipmentId,
                  merchandiseId: payload?.merchandiseId,
                  merchandiseDuties: {
                    merchandiseDutyId: item?.merchandiseDutyId,
                  },
                },
              ],
            },
          ],
        },
      },
    };

    return HttpClient.custom({ data });
  });

  await Promise.all(promises);
};

const createMerchandiseDuties = async (invoiceId, shipmentId, merchandiseId, duties) => {
  const responses = await Promise.all(
    duties.map((duty) => {
      const data = {
        eventType: 'SAVE_ENTRY_SUMMARY_FORM',
        eventTime: Date.now(),
        eventMessage: {
          shipmentId,
          descriptionOfMerchandise: {
            entrySummaryInvoices: [
              {
                invoiceId,
                merchandiseLineItems: [
                  {
                    shipmentId,
                    merchandiseId,
                    merchandiseDuties: [
                      {
                        "unitPrice": 0,
                        "htsus": duty,
                        "htsDescription": ""
                    }
                    ],
                  },
                ],
              },
            ],
          },
        },
      };

      return HttpClient.custom({ data });
    })
  );
  // Collect new duties with IDs from responses
  const created = responses
  .map((res) => res?.data?.eventMessage)
  
  return created;
};

const saveMerchandiseDuties = async (
  invoiceId,
  shipmentId,
  merchandiseId,
  duties,
  metaDataList
) => {
  const requests = duties.map((duty, index) => {
    const data = {
      eventType: 'SAVE_ENTRY_SUMMARY_DUTIES',
      eventTime: 1744361948182,
      eventMessage: {
        descriptionOfMerchandise: {
          entrySummaryInvoices: [
            {
              invoiceId: invoiceId,
              merchandiseLineItems: [
                {
                  merchandiseId: merchandiseId,
                  merchandiseDuties: [
                    {
                      merchandiseDutyId: duty?.merchandiseDutyId,
                      dutyRate: metaDataList[index]?.applicableDuty,
                      htsDescription: metaDataList[index]?.displayDescription,
                      priorityNumber: metaDataList[index]?.priorityNumber,
                      // isCommodityDuty: 1,
                      // otherRate: 'NaN',
                      // specificRate: 'NaN',
                      // manifestQuantity: {
                      //   quantity: '0.00',
                      //   units: 'NO',
                      // },
                    },
                  ],
                },
              ],
            },
          ],
        },
        shipmentId: shipmentId,
      },
    };

    return HttpClient.custom({ data });
  });

  await Promise.all(requests);
};

const getEntrySummary = async (shipmentId) => {
  const data = {
    eventType: 'GET_ENTRY_SUMMARY_FORM',
    eventTime: Date.now(),
    eventMessage: shipmentId,
  };

  const response = await HttpClient.custom({ data });
  return response?.data?.eventMessage;
};

export const updateTariffs = (payload) => async (dispatch, getState) => {
  const state = getState();
  const shipmentId = state.FormValues.shipmentId;
  const metaDataList = await getHtsMetadata(payload.tariffs, state);

  await deleteAdditionalHts(payload, shipmentId);
  const createdDuties = await createMerchandiseDuties(
    payload.invoiceId,
    shipmentId,
    payload.merchandiseId,
    payload.tariffs
  );

  await saveMerchandiseDuties(
    payload.invoiceId,
    shipmentId,
    payload.merchandiseId,
    createdDuties,
    metaDataList
  );
  const entrySummary = await getEntrySummary(shipmentId);
  const updatedDuties =
    entrySummary?.descriptionOfMerchandise?.entrySummaryInvoices
      ?.find((inv) => inv.invoiceId === payload.invoiceId) // match invoice
      ?.merchandiseLineItems?.find(
        (item) => item.merchandiseId === payload.merchandiseId
      )?.merchandiseDuties || []; // match merchandise

  dispatch({
    type: 'UPDATE_TARIFFS',
    payload: {
      ...payload,
      updatedDuties: updatedDuties.filter((d)=>d.isCommodityDuty === 2)
    },
  });
};

export const tariffLoader = (payload) => async (dispatch, getState) => {
  dispatch({
    type: 'TARIFFS_LOADER',
    payload,
  });
};

// export function displayFrightData(invoiceItemIndex,payload){
//   return {
//     type : "HIDE_UNHIDE_FRIEGHTDATA",
//     invoiceItemIndex,payload
//   }
// }

export const  updateAdditonDeduction=(data)=> {
    return (dispatch, getState) => {
      dispatch({
        type: actionTypes.UPDATE_ADDITION_DEDUCTION,
        data
        
      })
    }
  
  }

  export function saveMerchAdditionDeletion({lineItemIndex,invoiceItemIndex, dutyIndex, field, newxValue},callback) {

  return (dispatch, getState) => {
    let invoiceItem = getState().DescriptionOfMerchandise.entrySummaryInvoices[invoiceItemIndex];
    let lineItem = invoiceItem?.merchandiseLineItems[lineItemIndex];
    let duty = lineItem["merchandiseDuties"][dutyIndex];
   
    let fieldsToSave = {}
  
   
     if (field === 'totalAdditions') {
      fieldsToSave['additions']= {[field]:newxValue};
    }
     if (field === 'totalDeletions') {
      fieldsToSave['deletions']= {[field]:newxValue};
    }
  
    return saveDescriptionOfMerchandiseDutyItem(
      getState().DescriptionOfMerchandise.entrySummaryInvoices[invoiceItemIndex].merchandiseLineItems[lineItemIndex]
        .merchandiseId,
        getState().DescriptionOfMerchandise.entrySummaryInvoices[invoiceItemIndex].invoiceId,
      duty.merchandiseDutyId,
      {...fieldsToSave},
      duty.isCommodityDuty,
      lineItem.articleSetId,
      {},
      {eventType:"PRORATE_ADDITION_DEDUCTION"}
    ).then((res)=>{
     
      if(res.data.eventMessage)
        store.dispatch(updateAdditonDeduction(res.data.eventMessage));
     if(callback)
        callback()
     
    })
    .catch(e => {
      console.error('Error saving duty fields', field, e)
       if(callback)
          callback()
  })
  }
}

export function addAdditionalDeclarations(payload){
  return {
    type: actionTypes.ADD_ADDITIONAL_DECLARATIONS,
    payload
  };
}

export function deleteAdditionalDeclarations(payload){
  return {
    type: actionTypes.DELETE_ADDITIONAL_DECLARATIONS,
    payload
  };
}
